"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Link = _interopRequireDefault(require("../Link"));
var _TableCell = _interopRequireDefault(require("../TableCell"));
var _Table = _interopRequireDefault(require("../Table"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Button = _interopRequireDefault(require("../Button"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _index = _interopRequireDefault(require("./index.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GuestMenu = _ref => {
  var _selectedGuests$filte;
  let {
    className,
    icon = /*#__PURE__*/_react.default.createElement(_KeyboardArrowDown.default, null),
    labelMenu = '',
    labelCancel = '',
    labelDone = '',
    labelOnLapNote = '',
    unaccompaniedMinorError = 'Children may not travel alone, must be accompanied by passenger 18yrs or older',
    minAgeToTravelAlone = 12,
    minAgeToAccompanyMinors = 18,
    menuItems,
    id = 'guestMenu',
    onChoseDone = () => {},
    disabled = false
  } = _ref;
  const classes = (0, _index.default)();
  const ref = /*#__PURE__*/(0, _react.createRef)();
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const [selectedGuests, setSelectedGuests] = (0, _react.useState)(menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(guest => {
    return {
      ...guest,
      name: guest.name.toLowerCase().replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase())
    };
  }));
  const [preSelectedGuests, setPreselectedGuests] = (0, _react.useState)(menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(guest => {
    return {
      ...guest,
      name: guest.name.toLowerCase().replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase())
    };
  }));
  const open = Boolean(anchorEl);
  const validateRegularAdults = guests => {
    return guests === null || guests === void 0 ? void 0 : guests.some(guest => {
      return guest.selected && guest.age >= minAgeToAccompanyMinors;
    });
  };
  const disableDoneButton = () => {
    const activeGuests = selectedGuests === null || selectedGuests === void 0 ? void 0 : selectedGuests.filter(guest => guest.selected);
    return (activeGuests === null || activeGuests === void 0 ? void 0 : activeGuests.length) > 0 ? activeGuests.some(guest => {
      return guest.selected && guest.age < minAgeToTravelAlone;
    }) && !validateRegularAdults(activeGuests) : true;
  };
  const isGuestChecked = (event, index) => {
    const selected = event.target.checked;
    const selectedGuest = selectedGuests.map((guest, i) => {
      return index === i ? {
        ...guest,
        selected
      } : {
        ...guest
      };
    });
    setSelectedGuests(selectedGuest);
  };
  const changeOnLapSelection = index => {
    const selectedGuest = selectedGuests.map((guest, i) => {
      return index === i ? {
        ...guest,
        requiresFlightTicket: !guest.requiresFlightTicket
      } : {
        ...guest
      };
    });
    setSelectedGuests(selectedGuest);
  };
  const cancelOption = () => {
    setSelectedGuests(preSelectedGuests);
    setAnchorEl(null);
  };
  const doneOption = () => {
    setSelectedGuests(selectedGuests);
    setPreselectedGuests(selectedGuests);
    onChoseDone(selectedGuests);
    setAnchorEl(null);
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
  };
  const shouldDisplayOnLapNote = selectedGuests ? selectedGuests.some(guest => guest.allowOnLapOption) : false;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)(className)
  }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
    "data-testid": "guest-menu",
    component: "button",
    underline: "none",
    disable: "true",
    "aria-controls": id,
    "aria-haspopup": "true",
    className: "".concat(classes.label),
    onClick: handleClick
  }, selectedGuests === null || selectedGuests === void 0 || (_selectedGuests$filte = selectedGuests.filter(guest => guest.selected && (guest === null || guest === void 0 ? void 0 : guest.requiresFlightTicket))) === null || _selectedGuests$filte === void 0 ? void 0 : _selectedGuests$filte.length, " ".concat(labelMenu), icon)), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    className: (0, _clsx.default)(classes.root),
    "data-testid": "guest-menuPop",
    id: id,
    anchorEl: anchorEl,
    getContentAnchorEl: null,
    keepMounted: true,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    MenuListProps: {
      'data-testid': 'menulist'
    },
    onClose: cancelOption,
    open: open
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    ref: ref,
    className: classes.menuBody
  }, /*#__PURE__*/_react.default.createElement(_Table.default, null, /*#__PURE__*/_react.default.createElement(_core.TableBody, null, selectedGuests && selectedGuests.map((guest, index) => {
    const labelId = "enhanced-table-checkbox-".concat(index);
    return /*#__PURE__*/_react.default.createElement(_core.TableRow, {
      key: guest.name
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      width: 34,
      className: "guestSelector"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      disabled: disabled,
      inputProps: {
        'data-testid': "guest-checkbox-".concat(index)
      },
      onChange: event => isGuestChecked(event, index),
      checked: guest.selected
    })), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      className: "guestName",
      align: "left",
      id: labelId
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, guest.name), guest.selected && guest.age < minAgeToTravelAlone && !validateRegularAdults(selectedGuests) && /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: "unaccompaniedMinorError",
      variant: "caption"
    }, unaccompaniedMinorError)), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      className: "guestType",
      align: "center"
    }, guest.allowOnLapOption ? /*#__PURE__*/_react.default.createElement("div", {
      className: "onLapOptionSelectorContainer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "onLapOptionSelector"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "data-testid": "onSeatAction",
      disabled: guest.requiresFlightTicket,
      onClick: () => {
        changeOnLapSelection(index);
      }
    }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: "infantTypeLabel",
      variant: "body1"
    }, guest.flightPassengerType[guest.requiresFlightTicket ? 0 : 1]), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "data-testid": "onLapAction",
      disabled: !guest.requiresFlightTicket,
      onClick: () => {
        changeOnLapSelection(index);
      }
    }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null)))) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, guest.flightPassengerType)));
  }))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "guestButtonWrapper"
  }, shouldDisplayOnLapNote && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "caption"
  }, " ", labelOnLapNote), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "data-testid": "cancel",
    onClick: cancelOption,
    className: "cancelButton"
  }, labelCancel), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "data-testid": "done",
    onClick: doneOption,
    className: "doneButton",
    variant: "contained",
    color: "primary",
    disabled: disableDoneButton()
  }, labelDone)))));
};
var _default = exports.default = GuestMenu;